import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { SeaSearchCardModel } from "./model";

type SeaSearchCard = SeaSearchCardModel[];

const initialAppState: SeaSearchCard = [];

const seaSearchCardSlice = createSlice({
  name: "seaSearchCards",
  initialState: initialAppState,
  reducers: {
    prependSearchCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: SeaSearchCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    removeSearchCardAction: (state, action: PayloadAction<SeaSearchCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSearchCardAction: (state, action: PayloadAction<SeaSearchCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const seaSearchCardBaseSelector = createBaseSelector(seaSearchCardSlice);

registerSlice([seaSearchCardSlice]);

export const seaSearchCardStore = {
  actions: seaSearchCardSlice.actions,
  selectors: {
    searchCards: createSelector(seaSearchCardBaseSelector, (s) => s),
  },
};
